import { version } from "../../package.json";
import {
  API_SERVER_DOMAIN,
  CDN_SERVER_DOMAIN,
  LOGO,
  TILE_SERVER_DOMAIN,
} from "../constants";

export const VERSION = version;
export const TILES_CACHE_NAME = `tiles-cache-${VERSION}`;
export const CARTOGRAPHY_CACHE_NAME = `cartography-cache-${VERSION}`;
export const SOURCES_CACHE_NAME = `sources-cache-${VERSION}`;
export const AUTH_CACHE_NAME = `auth-cache-${VERSION}`;
export const CONFIG_CACHE_NAME = `config-cache-${VERSION}`;
export const MAPBOX_CACHE_NAME = "mapbox-cache";
export const CACHED_AT_HEADER_NAME = "x-cached-at";
export const INDEX_CACHE_ENTRY = "/index.html";

export const AUTH_KEY = "auth-context";

export const DRACO_LIBRARY_URLS = [
  "https://www.gstatic.com/draco/versioned/decoders/1.5.6/draco_wasm_wrapper.js",
  "https://www.gstatic.com/draco/versioned/decoders/1.5.6/draco_decoder.wasm",
  "https://unpkg.com/@loaders.gl/draco@4.3.3/dist/draco-worker.js",
];

export const MAPBOX_URLS = ["api.mapbox.com", "tiles.mapbox"];
export const API_SERVER_DOMAINS = [
  "dashboard.situm.com",
  "pro.situm.com",
  API_SERVER_DOMAIN,
];
export const API_DOMAINS = [
  ...API_SERVER_DOMAINS,
  "gis.",
  LOGO,
  TILE_SERVER_DOMAIN,
  CDN_SERVER_DOMAIN,
].flat();
